<template>
  <div v-if="show" class="uploaded-candidate-list">
    <div class="list-head"></div>
    <div class="list-container">
      <TableList
        class="candidate-list"
        no-operation
        :list-data="candidateList"
        :table-columns="candidateListColumns"
        :showCreateBtn="false"
        @selection-change="handleSelectionChange"
      >
        <template #filter-group>
          <span class="table-title">{{ $t(`${i18nPrefix}.containerTitle.parseSuccess`) }}</span>
        </template>
        <template #candidateName="{ row, data }">
          <span>{{ data }}</span>
          <span v-if="row.resume_info.duplicate_candidate_list.length > 0" class="duplicate-candidate-container">
            <DuplicateCandidatePopover
                v-if="hasDuplicateCandidatePermission && row.resume_info.duplicate_candidate_list && row.resume_info.duplicate_candidate_list.length > 0"
                class="candidate-icon duplicate-candidate"
                :duplicateCandidateList="row.resume_info.duplicate_candidate_list"
                @openDuplicateCandidateDetail="openDuplicateCandidateDetail"
              >
              <DuplicateCandidateIcon :size="14"></DuplicateCandidateIcon>
            </DuplicateCandidatePopover>
          </span>
        </template>
      </TableList>
      <TableList
        v-if="failList && failList.length > 0"
        class="fail-list"
        no-operation
        :list-data="failList"
        :table-columns="failListColumns"
        :showCreateBtn="false"
      >
        <template #filter-group>
          <span>{{ $t(`${i18nPrefix}.containerTitle.parseFail`) }}</span>
        </template>
      </TableList>
    </div>
    <div class="list-foot adapt-wrapper" v-if="candidateList.length > 0">
      <el-button class="import-btn" @click="handleImportBtnClick">{{ $t(`${i18nPrefix}.btn.import`) }}</el-button>
    </div>
  </div>
</template>

<script>
import TableList from '@/components/tableList/noBorderTable.vue'
import DuplicateCandidatePopover from '@/views/adminNew/application/components/duplicateCandidatePopover.vue'
import DuplicateCandidateIcon from '@/components/icon/duplicateCandidate.vue'

export default {
  components: {
    TableList,
    DuplicateCandidatePopover,
    DuplicateCandidateIcon
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    candidateList: {
      type: Array,
      required: true
    },
    failList: {
      type: Array
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.batchUpload',
      candidateSelection: []
    }
  },
  computed: {
    hasDuplicateCandidatePermission () {
      return this.hasAnyPermission('PREMIUM_DUPLICATE_CANDIDATE')
    },
    jobId () {
      return this.$route.params.jobId
    },
    candidateListColumns () {
      const columns = [
        {
          width: '48px',
          cellClass: 'table-selection',
          columnType: 'selection'
        },
        {
          width: '150px',
          cellClass: 'candidate-name-container',
          label: this.$t(`${this.i18nPrefix}.label.candidateName`),
          dataKey: 'resume_info.other_name',
          slotName: 'candidateName',
          showOverflowTooltip: false
        },
        {
          width: '120px',
          label: this.$t(`${this.i18nPrefix}.label.email`),
          dataKey: 'resume_info.email_address'
        },
        {
          width: '120px',
          label: this.$t(`${this.i18nPrefix}.label.phone`),
          dataKey: 'resume_info.mobile'
        },
        {
          width: '300px',
          cellClass: 'file-name',
          label: this.$t(`${this.i18nPrefix}.label.fileName`),
          dataKey: 'file_name',
          slotName: 'fileName'
        }
      ]
      return columns
    },
    failListColumns () {
      const columns = [
        {
          width: '430px',
          cellClass: 'file-name',
          label: this.$t(`${this.i18nPrefix}.label.fileName`),
          dataKey: 'file_name'
        },
        {
          width: '300px',
          label: this.$t(`${this.i18nPrefix}.label.failReason`),
          dataKey: 'status',
          formatter: (data) => {
            let i18nKey = ''
            if (data.endsWith('_FAIL')) {
              i18nKey = 'FAILED'
            } else if (['PARSE_FAIL_NO_CONTACT_INFO'].includes(data)) {
              i18nKey = 'NO_CONTACT_INFO'
            } else if (['PARSE_FAIL_EXISTED_HR_ACCOUNT'].includes(data)) {
              i18nKey = 'EXISTED_HR_ACCOUNT'
            } else if (['FINISHED', 'APPLICATION_EXISTED'].includes(data)) {
              i18nKey = data
            } else {
              i18nKey = 'WAITING'
            }
            return this.$t(`${this.i18nPrefix}.taskStatus.${i18nKey}`)
          }
        }
      ]
      return columns
    }
  },
  created () {

  },
  methods: {
    handleSelectionChange (candidate) {
      this.candidateSelection = candidate
    },
    handleImportBtnClick () {
      this.$emit('importCandidate', this.candidateSelection)
    },
    openDuplicateCandidateDetail (application) {
      const candidateId = application.candidateId
      const url = `${window.location.origin}/v-admin/talent-pool/candidate/profile?candidate_id=${candidateId}`
      window.open(url)
    },
    handleDuplicateIconClick (row) {
      row.showDuplicate = !row.showDuplicate
    }
  }
}
</script>

<style lang="scss" scoped>
.uploaded-candidate-list {
  $main-color: #6c6c6c;
  padding: 0 10px;

  .list-container {
    .duplicate-candidate-container {
      position: relative;
      margin-left: 6px;

      .duplicate-icon {
        vertical-align: middle;
        font-size: 35px;
        cursor: pointer;
      }
    }

    .candidate-list {
      .table-title {
        font-size: 18px;
        font-weight: 500;
        color: #303133;
      }
    }

  }

  .list-foot {
    margin-top: 50px;
    text-align: right;

    .import-btn {
      padding: 9px 28px;
      font-size: 16px;
      font-weight: 500;
      color: #FFFFFF;
      background-color: #0096cc;
    }
  }

  ::v-deep {
    .table-header {
      height: auto;
      margin-bottom: 22px;
      margin-top: 0;

      .filter-group {
        margin: 0;
        font-size: 18px;
      }
    }

    .table-container {
      .el-table {
        overflow: initial;

        .el-table__header-wrapper {
          .el-table__cell {
            text-align: left;
            font-size: 14px;
            .cell {
              padding: 0 10px;
            }
            &:first-child {
              text-align: center;
            }
          }
        }

        .el-table__body-wrapper {
          font-size: 14px;
          padding: 0 0 10px 0;
          overflow: initial;

          .el-table__cell {
            border-bottom: 1px solid #DFDFDF;
            text-align: left;
            font-size: 14px;
            .cell {
              padding: 0 10px;
            }
            &:first-child {
              text-align: center;
            }
          }
        }
      }
    }

    .el-table__header th.el-table__cell {
      background-color: #FAFAFA;
    }

    .el-table .cell.el-tooltip {
      min-width: 48px;
    }

    td.candidate-name-container {
      .cell {
        overflow: initial;
      }
    }

    td.file-name {
      text-align: left;
    }

    td.view-btn-group {
      .cell {
        padding: 10px 0;

        .el-button {
          padding-top: 0;
          padding-bottom: 0;
        }
      }
    }
  }
}

.duplicate-popup {
  .duplicate-candidate-list {
    .title {
      position: relative;

      .text {
        font-size: 14px;
        color: #232323;
        font-weight: bold;
        height: 25px;
        line-height: 25px;
      }

      .duplicate-icon {
        font-size: 35px;
        position: absolute;
        left: 243px;
        top: -4px;
      }
    }

    .content-wrapper {
      max-height: 380px;
      overflow: auto;

      .content {
        border-top: 1px solid #ccc;
        padding: 13px 0 6px;
        margin-right: 10px;

        &:last-child {
          border-bottom: none;
        }

        .avatar {
          display: inline-block;
          vertical-align: top;
          width: 50px;
          height: 50px;
        }

        .candidate-info {
          display: inline-block;
          margin-left: 10px;
          margin-top: -2px;

          .email {
            color: #0096cc;
            display: inline-block;
            font-size: 13px;
            width: 210px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          div {
            font-size: 12px;
            width: 210px;
            margin-bottom: 3px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #0096cc;

            &.name {
              font-size: 13px;
              cursor: pointer;
            }

            &.phone {
              color: #232323;
            }
          }

          .view-candidate-btn-container {
            text-align: right;
            margin: 5px 0 0;

            .view-btn {
              padding: 5px 15px;
              background-color: #0096cc;
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.duplicate-popup.el-popover {
  padding: 8px 0 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background-color: #f7f7f7;

  .popper__arrow {
    &::after {
      content: '';
      display: block;
      width: 10px;
      height: 10px;
      left: 0 !important;
      border: 1px solid #ccc;
      border-right: 0;
      border-left-width: 1px !important;
      border-bottom: 0;
      box-sizing: border-box;
      background-color: #f7f7f7;
      transform: rotate(-45deg);
      position: absolute;
    }
  }
}
</style>
